import React, { useState } from "react";

const Billing = ({ translate }) => {
  const [cart, setCart] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [walletAmount, setWalletAmount] = useState(1000);

  const addToCart = (event) => {
    event.preventDefault();
    const itemName = event.target.itemName.value;
    const itemPrice = parseFloat(event.target.itemPrice.value);

    if (itemName && !isNaN(itemPrice)) {
      setCart([...cart, { name: itemName, price: itemPrice }]);
      event.target.reset();
    } else {
      alert(translate("pleaseFillAllFields"));
    }
  };


  return (
    <div className="content active">
      <h2>{translate("billing")}</h2>
      <div className="billing-section">


        <h4>بسته شروع <a> - خرید</a></h4>
        <h4>بسته استاندارد <a> - خرید</a></h4>
        <h4>بسته حرفه ای<a> - خرید</a></h4>

      </div>
    </div>
  );
};

export default Billing;